import { MetricsDictionaryWithSelector } from "@tw/types/module/metrics/benchmarkMetrics";
import { metrics as allMetrics } from "./allMetrics";

export const supportedMetrics: MetricsDictionaryWithSelector = {
  "facebook-ads": {
    cpa: {
      ...allMetrics.cpa!,
      selector: "facebookCpaBenchmarksTotal",
      chart: "facebookCpaBenchmarksChart",
      provider: "facebook-ads",
      userSelector: "facebookCpa",
      userChart: "facebookCpaChart",
      tip: "Cost Per Acquisition. Facebook Ad Spend / Orders > $0",
    },
    cpc: {
      ...allMetrics.cpc!,
      selector: "facebookCpcBenchmarksTotal",
      chart: "facebookCpcBenchmarksChart",
      provider: "facebook-ads",
      userSelector: "averageFacebookCpc",
      userChart: "chartFacebookCpc",
      tip: "Cost Per Click",
    },
    roas: {
      ...allMetrics.roas!,
      selector: "facebookRoasBenchmarksTotal",
      chart: "facebookRoasBenchmarksChart",
      provider: "facebook-ads",
      userSelector: "fb_ads_purchase_roas",
      userChart: "chartFacebookPurchaseRoas",
      tip: "Return on Ad Spend. Order Revenue / Blended Ads",
    },
    cpm: {
      ...allMetrics.cpm!,
      selector: "facebookCpmBenchmarksTotal",
      chart: "facebookCpmBenchmarksChart",
      provider: "facebook-ads",
      userSelector: "averageFacebookCpm",
      userChart: "chartFacebookCpm",
      tip: "Facebook cost per 1000 impressions",
    },
  },
  "google-ads": {
    cpa: {
      ...allMetrics.cpa!,
      selector: "googleCpaBenchmarksTotal",
      chart: "googleCpaBenchmarksChart",
      provider: "google-ads",
      userSelector: "googleAllCpa",
      userChart: "googleAllCpaChart",
      tip: "Cost Per Acquisition. Google Ad Spend / Orders > $0",
    },
    cpc: {
      ...allMetrics.cpc!,
      selector: "googleCpcBenchmarksTotal",
      chart: "googleCpcBenchmarksChart",
      provider: "google-ads",
      userSelector: "googleCpc",
      userChart: "googleCpcChart",
      tip: "Cost Per Click",
    },
    roas: {
      ...allMetrics.roas!,
      selector: "googleRoasBenchmarksTotal",
      chart: "googleRoasBenchmarksChart",
      provider: "google-ads",
      userSelector: "ga_ROAS",
      userChart: "googleAdsRoasChart",
      tip: "Return on Ad Spend. Order Revenue / Blended Ads",
    },
    cpm: {
      ...allMetrics.cpm!,
      selector: "googleCpmBenchmarksTotal",
      chart: "googleCpmBenchmarksChart",
      provider: "google-ads",
      userSelector: "totalGoogleAdsCpm",
      userChart: "totalGoogleAdsCpmChart",
      tip: "Google Ads cost per 1000 impressions",
    },
  },
  "tiktok-ads": {
    cpa: {
      ...allMetrics.cpa!,
      selector: "tiktokCpaBenchmarksTotal",
      chart: "tiktokCpaBenchmarksChart",
      provider: "tiktok-ads",
      userSelector: "tiktokCpa",
      userChart: "tiktokCpaChart",
      tip: "Cost Per Acquisition. Tiktok Ad Spend / Orders > $0",
    },

    cpc: {
      ...allMetrics.cpc!,
      selector: "tiktokCpcBenchmarksTotal",
      chart: "tiktokCpcBenchmarksChart",
      provider: "tiktok-ads",
      userSelector: "averageTiktokCpc",
      userChart: "chartTiktokCpc",
      tip: "Cost Per Click",
    },
    roas: {
      ...allMetrics.roas!,
      selector: "tiktokRoasBenchmarksTotal",
      chart: "tiktokRoasBenchmarksChart",
      provider: "tiktok-ads",
      userSelector: "tiktokRoas",
      userChart: "tiktokRoasChart",
      tip: "Return on Ad Spend. Order Revenue / Blended Ads",
    },
    cpm: {
      ...allMetrics.cpm!,
      selector: "tiktokCpmBenchmarksTotal",
      chart: "tiktokCpmBenchmarksChart",
      provider: "tiktok-ads",
      userSelector: "averageTiktokCpm",
      userChart: "chartTiktokCpm",
      tip: "Tiktok cost per 1000 impressions",
    },
  },
  "triple-whale": {
    blendedCpa: {
      ...allMetrics.blendedCpa!,
      selector: "blendedCpaBenchmarksTotal",
      chart: "blendedCpaBenchmarksChart",
      provider: "triple-whale",
      tip: "Cost Per Acquisition. All-Channels Ad Spend / Orders > $0",
    },
    blendedCPC: {
      ...allMetrics.blendedCPC!,
      selector: "blendedCpcBenchmarksTotal",
      chart: "blendedCpcBenchmarksChart",
      provider: "triple-whale",
      tip: "Blended Cost Per Click. This includes data of each marketing channel connected to Triple Whale",
    },
    blendedRoas: {
      ...allMetrics.blendedRoas!,
      selector: "blendedRoasBenchmarksTotal",
      chart: "blendedRoasBenchmarksChart",
      provider: "triple-whale",
      color: "#10B981",
      tip: "Blended Return on Ad Spend. Order Revenue / Blended Ads",
    },
    blendedCpm: {
      ...allMetrics.blendedCpm!,
      selector: "blendedCpmBenchmarksTotal",
      chart: "blendedCpmBenchmarksChart",
      provider: "triple-whale",
      tip: "Blended cost per 1000 impressions",
    },
  },
};

export const colorsMetrics = ["#10B981", "#EA643D", "#B0446A", "#3159F3"];
